export const BASE_URL = 'https://storm-mountain.herokuapp.com';
export const ACTIVITIES_PATH = '/api/v1/activities';
export const SCHEDULES_PATH = '/api/v1/schedules';
export const USER_SCHEDULES_PATH = '/api/v1/user_schedules';
export const REGISTRATION_PATH = '/api/registrations';
export const SESSIONS_PATH = '/api/sessions';
